import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { RichText, useBlockProps } from '@wordpress/block-editor';
export default function save(_ref) {
  let {
    attributes
  } = _ref;
  const {
    content
  } = attributes;
  return createElement("pre", useBlockProps.save(), createElement(RichText.Content, {
    value: content
  }));
}
//# sourceMappingURL=save.js.map